import api from '@/api'

const store = {
  state: {
    dataStore: [],
    dataStoreForNewPort: [],
    oneStore: {},
    pagingStore: {
      page: 1,
      size: 20,
      total: 0
      // offset: 0,
      // max: 0
    },
    sortingStore: {
      byField: '',
      isDesc: false
    },
    filteringStore: {
      outletCode: null,
      name: null,
      address: null,
      ipAddress: null,
      port: null,
      phoneNumber: null,
      faxNumber: null,
      taxPercentage: null,
      deliveryCharge: null,
      takeAwayCharge: null,
      regionCode: null,
      regionName: null,
      areaCode: null,
      areaName: null,
      cityCode: null,
      cityName: null,
      rscCode: null,
      zipCode: null,
      type: null,
      isActive: null,
      latitude: null,
      longitude: null,
      isOpen24Hours: null,
      valueAddedTax: null,
      deliveryTax: null,
      restaurantTax: null
    },
    syncRestaurant: {
      isSyncing: false,
      data: null,
      error: null
    }
  },

  mutations: {
    SET_STORE: (state, payload) => {
      state.dataStore = payload
    },
    SET_STORE_NEW_PORT: (state, payload) => {
      state.dataStoreForNewPort = payload
    },
    SET_ONE_STORE: (state, payload) => {
      state.oneStore = payload
    },
    SET_PAGING_PAGE_STORE: (state, payload) => {
      state.pagingStore.page = payload
    },
    SET_PAGING_TOTAL_STORE: (state, payload) => {
      state.pagingStore.total = payload
    },
    SET_SORTING_STORE: (state, payload) => {
      state.sortingStore = payload
    },
    SET_FILTERING_STORE: (state, payload) => {
      state.filteringStore = payload
    },
    SET_SYNC_RESTAURANT_SYNCING: (state, payload) => {
      state.syncRestaurant.isSyncing = payload
    },
    SET_SYNC_RESTAURANT_DATA: (state, payload) => {
      state.syncRestaurant.data = payload
    },
    SET_SYNC_RESTAURANT_ERROR: (state, payload) => {
      state.syncRestaurant.error = payload
    }
  },

  getters: {
    SortingStore: state => state.sortingStore,
    FilteringStore: state => state.filteringStore,
    PagingStore: state => state.pagingStore,
    GetAllStore: state => state.dataStore,
    GetAllStoreForNewPort: state => state.dataStoreForNewPort,
    GetOneStore: state => id =>
      state.dataStore.find(dataStore => dataStore.id === id),
    GetSyncRestaurant: state => state.syncRestaurant,
    GetOneStoreForNewPort: state => state.oneStore
  },

  actions: {
    async UpdateSortingStore({ commit, dispatch }, payload) {
      commit('SET_SORTING_STORE', {
        byField: payload.byField,
        isDesc: payload.isDesc
      })
      dispatch('GetAllStoreForNewPort', payload.uid)
    },

    async UpdateFilteringStore({ commit, dispatch }, isResetField) {
      if (isResetField) {
        const emptyFilter = {
          cond: null,
          code: null,
          description: null
        }
        commit('SET_FILTERING_STORE', emptyFilter)
      }
      commit('SET_PAGING_PAGE_STORE', 1)
      dispatch('GetAllStoreForNewPort', isResetField.uid)
    },

    async GetAllStore({ commit, state }) {
      try {
        commit('SET_IS_FETCHING_DATA', true)
        const result = await api.GetAllStore(
          state.pagingStore,
          state.sortingStore,
          state.filteringStore
        )
        commit('SET_IS_FETCHING_DATA', false)
        commit('SET_PAGING_TOTAL_STORE', result.headers['data-length'])
        commit('SET_STORE', result.data.data)
        return result.data
      } catch (e) {
        commit('SET_IS_FETCHING_DATA', false)
        throw e
      }
    },

    async CreateStore({ dispatch }, payload) {
      try {
        const { data } = await api.CreateStore(payload)
        dispatch('GetAllStore')
        return data
      } catch (e) {
        return e.response
      }
    },

    async UpdateStore({ dispatch }, payload) {
      try {
        const { data } = await api.UpdateStore(payload.id, payload)
        dispatch('GetAllStore')
        return data
      } catch (e) {
        return e.response
      }
    },

    async DeleteStore({ dispatch }, id) {
      try {
        const { data } = await api.DeleteStore(id)
        dispatch('GetAllStore')
        return data
      } catch (e) {
        return e.response
      }
    },

    async SyncRestaurantInfo({ commit }, outletCode) {
      try {
        const result: any = await api.GetRestaurantInfo(outletCode)
        if (result.data.intro && result.data.intro.id) {
          commit('SET_SYNC_RESTAURANT_DATA', result.data.intro)
        } else {
          commit('SET_SYNC_RESTAURANT_ERROR', 'Restaurant not exist')
        }
        commit('SET_SYNC_RESTAURANT_SYNCING', false)
      } catch (e) {
        commit('SET_SYNC_RESTAURANT_SYNCING', false)
        commit('SET_SYNC_RESTAURANT_ERROR', e.message)
      }
    },

    async CheckStore({ dispatch, commit }, payload) {
      commit('SET_SYNC_RESTAURANT_SYNCING', true)
      commit('SET_SYNC_RESTAURANT_DATA', null)
      commit('SET_SYNC_RESTAURANT_ERROR', null)
      try {
        if (payload.needCheck) {
          const result = await api.CheckStoreInfo(payload.outletCode)
          if (!result.data.data) {
            dispatch('SyncRestaurantInfo', payload.outletCode)
          } else {
            commit('SET_SYNC_RESTAURANT_SYNCING', false)
            commit('SET_SYNC_RESTAURANT_ERROR', 'Outlet already exist')
          }
        } else {
          dispatch('SyncRestaurantInfo', payload.outletCode)
        }
      } catch (e) {
        commit('SET_SYNC_RESTAURANT_SYNCING', false)
        commit('SET_SYNC_RESTAURANT_ERROR', e.response.data.message)
      }
    },

    /**
     * The following methods are methods for requesting new interfaces
     */
    async GetStorePin({ commit }, payload) {
      try {
        return await api.GetStorePin(payload)
      } catch (e) {
        throw e
      }
    },

    async GetAllStoreForNewPort({ commit, state }, payload) {
      try {
        commit('SET_IS_FETCHING_DATA', true)
        const result = await api.GetAllStoreForNewPort(
          state.pagingStore,
          state.sortingStore,
          state.filteringStore,
          payload
        )
        commit('SET_IS_FETCHING_DATA', false)
        commit('SET_PAGING_TOTAL_STORE', result.data.result.count)
        commit('SET_STORE_NEW_PORT', result.data.result.data)
        return result
      } catch (e) {
        commit('SET_IS_FETCHING_DATA', false)
        throw e
      }
    },

    async GetOneStoreForNewPort({ commit }, payload) {
      try {
        commit('SET_IS_FETCHING_DATA', true)
        const result = await api.GetOneStoreForNewPort(payload)
        commit('SET_IS_FETCHING_DATA', false)
        for (let i = 0; i < result.data.result.building_fee.length; i++) {
          const item = result.data.result.building_fee[i]
          item.building_name = item.building_name + `(${item.id})`
        }
        commit('SET_ONE_STORE', result.data.result)
        return result
      } catch (e) {
        commit('SET_IS_FETCHING_DATA', false)
        throw e
      }
    },

    async CreateStoreForNewPort({ dispatch }, payload) {
      try {
        const { data } = await api.CreateStoreForNewPort(payload)
        dispatch('GetAllStoreForNewPort')
        return data
      } catch (e) {
        return e.response
      }
    },

    async UpdateStorePin({ dispatch }, payload) {
      try {
        const { data } = await api.UpdateStorePin(payload)
        return data
      } catch (e) {
        return e.response
      }
    },

    async CheckStorePin({ dispatch }, payload) {
      try {
        const { data } = await api.CheckStorePin(payload)
        return data
      } catch (e) {
        return e.response
      }
    },

    async UpdateStoreForNewPort({ dispatch }, payload) {
      try {
        const { data } = await api.UpdateStoreForNewPort(payload)
        dispatch('GetAllStoreForNewPort')
        return data
      } catch (e) {
        return e.response
      }
    },

    async DeleteStoreForNewPort({ dispatch }, id) {
      try {
        const { data } = await api.DeleteStoreForNewPort(id)
        dispatch('GetAllStoreForNewPort')
        return data
      } catch (e) {
        return e.response
      }
    },
    async GetStoreTables({ dispatch }, outletCode) {
      try {
        const { data } = await api.GetStoreTables(outletCode)
        return data
      } catch (e) {
        return e.response
      }
    },
    async SetNewTable({ dispatch }, params) {
      try {
        const { data } = await api.SetNewTable(params)
        return data
      } catch (e) {
        return e.response
      }
    },
    async GetBuildings({ dispatch }, outletCode) {
      try {
        const { data } = await api.GetBuildings(outletCode)
        return data
      } catch (e) {
        return e.response
      }
    }
  }
}

export default store
